import { render, staticRenderFns } from "./RegistrationSecondFactor.vue?vue&type=template&id=547d0467&scoped=true&"
import script from "./RegistrationSecondFactor.vue?vue&type=script&lang=js&"
export * from "./RegistrationSecondFactor.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationSecondFactor.vue?vue&type=style&index=0&id=547d0467&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547d0467",
  null
  
)

export default component.exports